export default "__VITE_ASSET__CjRvHGGu__"